/** Supported UI languages for the language selector. */
export const SUPPORTED_LANGUAGES = [
  { value: 'en-US', label: 'English (US)' },
  { value: 'en-GB', label: 'English (UK)' },
  { value: 'de-DE', label: 'Deutsch' },
  { value: 'fr-FR', label: 'Français' },
  { value: 'es-ES', label: 'Español' },
  { value: 'it-IT', label: 'Italiano' },
  { value: 'pt-BR', label: 'Português (BR)' },
  { value: 'ja-JP', label: '日本語' },
  { value: 'zh-CN', label: '中文 (简体)' },
  { value: 'zh-TW', label: '中文 (繁體)' },
  { value: 'ko-KR', label: '한국어' },
  { value: 'ar-AE', label: 'العربية' },
  { value: 'hi-IN', label: 'हिन्दी' },
] as const;

/** Badge photo base URL — requires Midway cookie (works on *.amazon.com domains). */
export const BADGE_PHOTO_URL = 'https://badgephotos.corp.amazon.com/?uid=';

/** External link URLs shared across the app. */
export const STRIDER_WIKI_URL =
  'https://w.amazon.com/bin/view/INTech/TranslationServices/STRIDER/';
export const SLACK_CHANNEL_URL =
  'https://app.slack.com/client/E015GUGD2V6/C070GHZPZ45';

/**
 * STRIDER ticket queue — opens the TT create form with the CTI pre-pinned to
 * `i18n / LMS / Service`, which routes to the STRIDER resolver group. Pinning
 * the CTI auto-populates the remaining routing fields, so the reporter only
 * fills in the title, description, and severity.
 */
export const CUT_TICKET_URL =
  'https://t.corp.amazon.com/create/options?category=i18n&type=LangHub&item=General';

/** Destination for the header Feedback link. */
export const FEEDBACK_URL =
  'https://t.corp.amazon.com/create/options?category=i18n&type=LangHub&item=General';
